import { newE2EPage } from "@stencil/core/testing";

describe("uic-tile", () => {
    it("renders", async () => {
        const page = await newE2EPage();
        await page.setContent("<uic-tile></uic-tile>");

        const element = await page.find("uic-tile");
        expect(element).toHaveClass("hydrated");
    });
});
